import React from 'react';

const BreakView = (props) => {
    const label = props.breakLabel;
    const className = props.breakClassName || 'break';

    return (
        <li className={className}>
            <span>{label}</span>
        </li>
    );
};

BreakView.PropTypes = {
    breakLabel: React.PropTypes.string,
    breakClassName: React.PropTypes.string
};

export default BreakView;



/** WEBPACK FOOTER **
 ** ./src/components/pagination/BreakView.jsx
 **/